import type { ComponentProps, JSXElementConstructor, ReactElement } from 'react'
import { isValidElement } from 'react'

export const isComponentInstance = <
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    TElement extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>,
>(
    node: unknown,
    expected: TElement,
): node is ReactElement<ComponentProps<TElement>> => isValidElement(node) && node.type === expected
